import React, { useState } from "react";

const Chatbot = ({ onClose }) => {
  const [messages, setMessages] = useState([
    { role: "assistant", content: "Welcome! How can I help you today?" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!input.trim()) return;

    // Add user message
    const newMessages = [...messages, { role: "user", content: input }];
    setMessages(newMessages);
    setInput("");
    setLoading(true);

    try {
      // 🔑 Replace with your real API key
      const OPENAI_API_KEY = "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";

      const response = await fetch("https://api.openai.com/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${OPENAI_API_KEY}`,
        },
        body: JSON.stringify({
          model: "gpt-3.5-turbo",
          messages: newMessages.map((msg) => ({
            role: msg.role,
            content: msg.content,
          })),
        }),
      });

      const data = await response.json();
      const aiReply = data.choices?.[0]?.message?.content || "Sorry, I didn’t understand that.";

      // Add AI response
      setMessages((prev) => [...prev, { role: "assistant", content: aiReply }]);
    } catch (error) {
      console.error("Chat error:", error);
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: "Oops! Something went wrong. Please try again." },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSend();
  };

  return (
    <div
      className="chatbot-container"
      style={{
        width: "350px",
        height: "500px",
        borderRadius: "12px",
        border: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        background: "#fff",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div
        className="chatbot-header"
        style={{
          background: "#007bff",
          color: "#fff",
          padding: "10px 15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Chatbot</span>
        <button
          onClick={onClose}
          style={{
            background: "transparent",
            border: "none",
            color: "#fff",
            fontSize: "18px",
            cursor: "pointer",
          }}
        >
          ×
        </button>
      </div>

      {/* Messages */}
      <div
        className="chatbot-messages"
        style={{
          flex: 1,
          padding: "10px",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {messages.map((msg, index) => (
          <div
            key={index}
            style={{
              alignSelf: msg.role === "user" ? "flex-end" : "flex-start",
              background: msg.role === "user" ? "#007bff" : "#f1f1f1",
              color: msg.role === "user" ? "#fff" : "#000",
              padding: "8px 12px",
              borderRadius: "10px",
              maxWidth: "80%",
            }}
          >
            {msg.content}
          </div>
        ))}
        {loading && (
          <div
            style={{
              fontStyle: "italic",
              color: "#666",
              fontSize: "14px",
            }}
          >
            AI is typing...
          </div>
        )}
      </div>

      {/* Input */}
      <div
        className="chatbot-input"
        style={{
          borderTop: "1px solid #ddd",
          padding: "8px",
          display: "flex",
          gap: "5px",
        }}
      >
        <input
          type="text"
          placeholder="Type a message..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{
            flex: 1,
            border: "1px solid #ccc",
            borderRadius: "6px",
            padding: "8px",
          }}
        />
        <button
          onClick={handleSend}
          disabled={loading}
          style={{
            background: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "8px 12px",
            cursor: "pointer",
          }}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default Chatbot;
